import CopyableValue from "components/CopyableValue";
import EntityCampaignsPanel from "components/sidebar/sections/EntityCampaignsPanel";
import {
  CustomFieldsPanelSection,
  PanelField,
  PanelSection,
} from "components/sidebar/sections/InfoPanel";
import TagsPanelSection from "components/sidebar/sections/TagsPanelSection";
import CONFIG from "Config";
import { buildSidebarAddresses } from "helpers/address";

// Read-only information for the entity detail rail. The tag dropdown in the
// tags section applies tags; the user's "Show disabled tags" preference governs
// which tags the dropdown and list show, and the record fetch honours it, so no
// client-side tag filtering is needed here.
const EntityInfoPanel = ({
  entity,
  showDisabledTags,
  onUpdate,
  isLoading = false,
}) => (
  <>
    <PanelSection isLoading={isLoading}>
      <PanelField label="Alternate Names">
        {entity?.alternate_names?.map(an => an.name)}
      </PanelField>
      <PanelField label="Addresses">{buildSidebarAddresses(entity)}</PanelField>
      <PanelField label="Websites">
        {entity?.urls?.map(url => (
          <CopyableValue key={url} value={url} />
        ))}
      </PanelField>
      <PanelField label="Email BCC">
        {CONFIG.CC_EMAIL ? (
          <CopyableValue value={CONFIG.CC_EMAIL} />
        ) : (
          "Not Configured"
        )}
      </PanelField>
      <PanelField label="Account Manager">
        {entity?.account_managers?.map(({ user_full_name }) => (
          <span key={user_full_name}>{user_full_name}</span>
        ))}
      </PanelField>
      <PanelField label="External CC Emails">
        {entity?.external_cc_emails ? (
          <CopyableValue value={entity.external_cc_emails} />
        ) : null}
      </PanelField>
      <PanelField label="Region">{entity?.region_name}</PanelField>
      <PanelField label="Country">
        {entity?.country_name || entity?.country}
      </PanelField>
    </PanelSection>

    <TagsPanelSection
      title="Tags"
      modelType="Entity"
      record={entity}
      isLoading={isLoading}
      showDisabledTags={showDisabledTags}
      onUpdate={onUpdate}
    />

    <CustomFieldsPanelSection
      title="Custom Fields"
      items={entity?.custom_fields}
      modelType="Entity"
      isLoading={isLoading}
    />

    {entity?.id && <EntityCampaignsPanel entityId={entity.id} />}
  </>
);

export default EntityInfoPanel;
